"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var MDIcon_1 = require("../../components/MDIcon");
var Popover_1 = require("../../components/Popover");
var ListView_1 = require("../../components/ListView");
var R = __importStar(require("../../utils/ramda"));
var classnames_1 = __importDefault(require("classnames"));
var Row_1 = require("../../components/Row");
var Button_1 = require("../../components/Button");
var filterOptionResults = function (options, params) {
  if (R.type(options) === "Function") {
    var results = options(params);
    var predicate = function (v) {
      return R.isNil(v) || v === false;
    };
    return R.reject(predicate, results);
  } else {
    return options;
  }
};
var ActionMenu = function (_a) {
  var _b, _c;
  var options = _a.options,
    params = _a.params,
    rowData = _a.rowData;
  var _d = __read((0, react_1.useState)(false), 2),
    isOpen = _d[0],
    setOpen = _d[1];
  (0, react_1.useEffect)(function () {
    params.eGridCell.classList.add("vsx-action-menu-cell");
    isOpen ? params.eGridCell.classList.add("open") : params.eGridCell.classList.remove("open");
  }, [isOpen]);
  var _options = filterOptionResults(options, params);
  var MenuInner = (0, react_1.useCallback)(function () {
    return (0, jsx_runtime_1.jsx)(ListView_1.ListView, {
      data: _options,
      onClick: function (o) {
        o.onClick && o.onClick({
          params: params,
          rowData: rowData
        });
        setOpen(false);
      },
      itemStyle: {
        padding: "calc(var(--ag-grid-size)/2)"
      },
      className: "vsx-action-menu-list",
      renderContent: function (o) {
        return (0, jsx_runtime_1.jsx)(ActionMenuOption, __assign({
          noIcon: R.all(function (o) {
            return R.isNothing(o.icon);
          }, _options)
        }, o));
      }
    });
  }, []);
  return _options.length > 0 ? (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
    customColor: "var(--action-menu-secondary-color)",
    className: "vsx-action-menu",
    appendTo: (_c = (_b = params.eGridCell.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) !== null && _c !== void 0 ? _c : document.body,
    content: (0, jsx_runtime_1.jsx)(MenuInner, {}),
    placement: "right-start",
    onClickOutside: function () {
      return setOpen(false);
    },
    shown: isOpen,
    contentStyle: {
      padding: 0
    }
  }, {
    children: (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
      className: (0, classnames_1.default)("vsx-action-menu-button", isOpen && "active"),
      round: true,
      icon: "dots-vertical",
      cursor: "pointer",
      onClick: function () {
        return setOpen(!isOpen);
      }
    })
  })) : null;
};
exports.ActionMenu = ActionMenu;
var ActionMenuOption = function (_a) {
  var noIcon = _a.noIcon,
    label = _a.label,
    _b = _a.icon,
    icon = _b === void 0 ? "blank" : _b;
  var iconElement = (0, react_1.useMemo)(function () {
    var props = typeof icon === "string" ? {
      icon: icon
    } : icon;
    return (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, __assign({
      size: "1.2em",
      align: "middle",
      className: "vsx-action-menu-icon"
    }, props));
  }, []);
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    align: "center",
    className: "vsx-action-menu-item"
  }, {
    children: [!noIcon && iconElement, label && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-action-menu-item-label"
    }, {
      children: label
    }))]
  }));
};